import { useTextStyles } from './Text.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Text = ({
  text,
  size,
  weight,
  color
}) => {
  const style = useTextStyles({
    size,
    weight,
    color
  });
  return /*#__PURE__*/_jsx("span", {
    style: style,
    children: text
  });
};
export default Text;